import * as React from 'react';
import FormGroup from '../input/FormGroup';
import { TLCode } from '../../../common/enums';
import { css } from 'glamor';

interface SimpleTextFormContentProps {
  label: TLCode | string;
  small?: boolean;
}

export default class SimpleTextFormContent extends React.Component<SimpleTextFormContentProps> {
  public static defaultProps: Partial<SimpleTextFormContentProps> = {
    small: true,
  };

  public render() {
    const cls = !this.props.small
      ? css({
          '& .bp3-form-content': {
            lineHeight: '25px',
          },
        })
      : css({ '& .bp3-form-group.bp3-inline label.bp3-label ': { lineHeight: '18px' } });
    return (
      <div
        className={`${cls} ${css({
          '& .bp3-form-content': {
            overflow: 'hidden',
          },
        })}`}
      >
        <FormGroup inline={true} label={this.props.label}>
          {this.props.children}
        </FormGroup>
      </div>
    );
  }
}
